import { Component, Input } from '@angular/core';
import { Audesp4ConvenioEstadual, Audesp4ExistenciaRecursosSim } from 'eddydata-lib';
import { BaseLicitacaoAudesp } from '../../util/base-licitacao-audesp';
//import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-convenio-est',
  templateUrl: './licitacao-audesp-convenio-est.component.html'
})
export class LicitacaoAudespConvenioEstComponent extends BaseLicitacaoAudesp {

  @Input() public recurso: Audesp4ExistenciaRecursosSim;

  public itemAtual: Audesp4ConvenioEstadual;
  public itemAnterior: Audesp4ConvenioEstadual;

  constructor() {
    super()
  }

  public adicionar() {
    if (!this.recurso.TransferenciasConveniosEstaduais || this.recurso.TransferenciasConveniosEstaduais.length === 0) this.recurso.TransferenciasConveniosEstaduais = [];

    this.itemAtual = {
      ConvenioEstadualNum: { Numero: undefined, Ano: undefined },
      ContrapartidaConvenioEstadualValor: undefined, RepasseConvenioEstadualValor: undefined,
      editavel: true
    }
    this.recurso.TransferenciasConveniosEstaduais.push(this.itemAtual);
  }

  public visualizar(item: Audesp4ConvenioEstadual) {
    this.itemAnterior = Object.assign({}, item);
    this.itemAtual = item;
    this.itemAtual.editavel = true;
    this.itemAtual['edicao'] = true;
  }

  public cancelar() {
    if (this.itemAtual['edicao']) {
      let itm = this.recurso.TransferenciasConveniosEstaduais.find((item) => item === this.itemAtual);
      itm = Object.assign({}, this.itemAnterior);
      this.recurso.TransferenciasConveniosEstaduais.splice(this.recurso.TransferenciasConveniosEstaduais.indexOf(this.itemAtual), 1, itm)
    } else {
      this.remover(this.itemAtual);
    }
    this.itemAtual.editavel = false;
    this.itemAnterior = undefined;
    this.itemAtual = undefined;
  }

  public remover(item: Audesp4ConvenioEstadual) {
    this.itemAtual = undefined;
    this.recurso.TransferenciasConveniosEstaduais.splice(this.recurso.TransferenciasConveniosEstaduais.indexOf(item), 1)
  }

  public salvar() {
    this.itemAtual.editavel = false;
    this.itemAtual = undefined;
  }

  permitirSomenteLetrasENumeros(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9]+$/;
    const key = event.key;

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }
}
